import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IDataDescriptionMapping, IDataHistoryQtDesc, IHistoryQr } from '../../Products.interface';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '@shared/interface/table.interface';
import { IQueryParams } from '@shared/interface/urlparam.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UrlUtilsService } from '@utils/url-utils.service';
import { UtilitiesService } from '@services/utilities.service';
import { getHistoryQrTableColumns } from '../../products.data';
import { FilterService } from '@services/filter.service';

@Component({
  selector: 'app-history-qr',
  templateUrl: './history-qr.component.html',
  styleUrls: ['./history-qr.component.scss'],
})
export class HistoryQrComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, { static: false }) matSort: MatSort;
  tableColumns: TableColumn[];
  displayedColumns: string[];
  qrHistoryList: IHistoryQr[];
  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_QR_CODE;
  baseDatasource: BaseDatasource<IHistoryQr>;
  tableColumn = ['id', 'status', 'action'];
  dataDescHistoryQr: IDataHistoryQtDesc;
  dataHistoryHeader: BehaviorSubject<IDataDescriptionMapping | undefined> = new BehaviorSubject<IDataDescriptionMapping | undefined>(undefined);
  brandId: string;
  string_filter?: string;
  private unsubscribe: Subscription[] = [];

  constructor(
    private baseTableService: BaseTableService<any>,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private baseService: BaseService,
    public utilities: UtilitiesService,
    private ref: ChangeDetectorRef,
    private urlParamService: UrlUtilsService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.brandId = this.activeRoute.snapshot.params.id;
    this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasource = response));

    this.setTableData();
    this.queryHandler();
    this.initPageInfo();

    this.getDataDescription();
  }

  queryHandler() {
    const paramsSubs = this.activeRoute.queryParams.subscribe(() => {
      const _param = this.urlParamService.sliceQueryParams();
      this.baseTableService.loadDataTable(API.GET_LIST_HISTORY_QR + this.brandId, _param ? _param : '');
    });

    this.unsubscribe.push(paramsSubs);
  }

  initPageInfo() {
    const dataSubs = this.baseDatasource.tableSubject.subscribe((val) => (this.qrHistoryList = val));
    this.unsubscribe.push(dataSubs);
  }

  setTableData() {
    this.tableColumns = getHistoryQrTableColumns();

    this.displayedColumns = this.tableColumns.map((item) => item.key);

    if (this.qrHistoryList) {
      this.baseDatasource.tableSubject.next(this.qrHistoryList);
    }
  }

  handleAction(): void {}

  changePageEvent($event: BaseDatasource<any>) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  sortTable(param: Sort) {
    const sortby = this.tableColumns.find((column) => column.key === param.active);
    param.active = sortby?.key ?? '';
    return this.sortDataSource(param);
  }

  sortDataSource(sortParams: Sort) {
    let { active } = sortParams;
    const {direction} = sortParams;
    active = active === 'created_date' ? 'createdDate' : active;

    if (sortParams.direction) {
      const dataParam: IQueryParams = {
        sort: active + ',' + direction,
      };

      return this.router.navigate([], {
        queryParams: {
          ...dataParam,
        },
        queryParamsHandling: 'merge',
      });
    } else {
      const snapshot = this.activeRoute.snapshot;
      const dataParam = { ...snapshot.queryParams };
      delete dataParam.sort;
      return this.router.navigate([], { queryParams: dataParam });
    }
  }

  getDataDescription() {
    this.baseService.getData<IDataHistoryQtDesc>(API.GET_DESC_HISTORY_QR + this.brandId).subscribe((res) => {
      if (res?.data) {
        this.dataDescHistoryQr = res.data;
        this.dataHistoryHeader.next([
          { value: this.dataDescHistoryQr.total_qr_injected + ' Set', label: 'Total QR dibuat' },
          { value: this.dataDescHistoryQr.total_spm_scanned + ' Set', label: 'Total Scan SPM' },
          { value: this.dataDescHistoryQr.total_qr_r2_scanned + ' Pcs', label: 'Total Scan Retailer' },
        ]);
        this.ref.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb: Subscription) => sb.unsubscribe());
  }
}

// todo: remove unused methods
